import { render } from "./TherapyActivityManagement.vue?vue&type=template&id=a81abcec&scoped=true"
import script from "./TherapyActivityManagement.vue?vue&type=script&lang=js"
export * from "./TherapyActivityManagement.vue?vue&type=script&lang=js"

import "./TherapyActivityManagement.vue?vue&type=style&index=0&id=a81abcec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a81abcec"]])

export default __exports__